<template>
    <div class="mod mod-half mod-temperature">
        <h2><i>4</i>持仓温度</h2>
        <div class="chart-wrap">
            <div class="chart-wrap-inner">
                <p class="chart-tips">更新于{{dataUpdateTime}}</p>

                <div class="temp-chart fl">
                    <svg class="svg-circle" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="60" cy="60" r="56" stroke-width="8" class="c_gray" style="stroke-dasharray:187 187;" stroke-linecap="round"></circle>
                        <circle cx="60" cy="60" r="56" stroke-width="8" class="c_highlight" :style="holding_temperature | stroke_dasharray" stroke-linecap="round"></circle>
                        <!-- 半圈：187 -->
                    </svg>
                    <span class="temp-num" v-bind:class="classTemperatureGradeObject" ><b>{{holding_temperature}}</b>℃</span>
                </div>

                <div class="chart-temperature-info">
                    <p>持仓温度：{{holding_temperature}}℃ <i class="icon-help" v-on:click="toggle">?</i></p>
                    <small v-text="holdingProposal">持仓建议：宜较低仓位</small>
                </div>
                <p class="help-pop" style="display: block" v-show="isHelp" >小贴士：温度值在50℃以上较好，20℃以下预警。</p>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState,mapMutations } from 'vuex'
    import date from '@/utils/date.js'
    export default {
        data () {
            return {
                isHelp:false,
                dataUpdateTime:'',
                holding_temperature:"--",
                classTemperatureGradeObject:{},
                holdingProposal:"--",
                stk_data:[],
                stock_pool:[],
                block_stat:{}
            }
        },
        filters: {
            stroke_dasharray: function (value) {
                return "stroke-dasharray:"+value+" 500"
            },
        },

        created:function() {
            this.getDataUpdateTime();
        },
        computed: {
            ...mapState(['isBlankPage'])
            //this.BlankPage;
        },
        mounted(){
            this.getData();
        },
        methods: {
            ...mapMutations(['changeBlankPage']),
            getData:function(){
                var _this=this;
                var Pro = Promise.all([_this.getStkdata(), _this.getStockpool(),_this.getBlockstat()]);
                Pro.then(function(data){
                        _this.stk_data=data[0][0];
                        _this.stock_pool=data[1][0];
                        _this.block_stat=data[2][0];
                        //MACD金叉个股数
                        var MACD_jcggs=_this.stock_pool.Pooldata[0].Stk.length;
                        //交易个股数
                        var jyggs=_this.block_stat.ZhangDiePing.ShangZhangJiaShu+_this.block_stat.ZhangDiePing.XiaDieJiaShu+_this.block_stat.ZhangDiePing.PingPanJiaShu-_this.block_stat.TingPaiJiaShu;
                        //上涨个股数
                        var szggs=_this.block_stat.ZhangDiePing.ShangZhangJiaShu;
                        _this.holding_temperature =Math.round(MACD_jcggs/jyggs*50+szggs/jyggs*50);
                        _this.setTemperatureGrade();
                    })
                    .catch(err=>{
                        console.log(err);
                    })
            },
            getStkdata:function () {
                return new Promise(function (resolve, reject){
                    dzhyun.query('/stkdata', { sub:'0',output:'json',obj:'SH000300',field:'ZhongWenJianCheng,ZhangDie' },(data)=>{
                        //...
                    }).then(function(data) {
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },
            getStockpool:function () {
                return new Promise(function (resolve, reject){
                    dzhyun.query('/stockpool', { sub:'0',output:'json',pool:'复盘神器',cell:'MACD>0' }, function(data) {
                        //...
                    }).then(function(data) {
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },
            getBlockstat:function () {
                return new Promise(function (resolve, reject){
                    dzhyun.query('/blockstat', { sub:'0',output:'json',obj:'SH000300',field:'ZhangDiePing,ZhangTingDieTing,TingPaiJiaShu',gql:'block=市场\\\\沪深市场\\\\上证A股 or block=市场\\\\沪深市场\\\\深证A股' }, function(data) {
                        //...
                    }).then(function(data) {
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },
            // 数据更新时间
            getDataUpdateTime:function (){
               date.getDataUpdateTime()
                    .then(response => {
                            // 执行成功的回调函数
                            this.dataUpdateTime=response.updateTime;
                            if(response.isTradingDay && date.timeRange("9:25","9:30")){
                                this.changeBlankPage(true)
                            }else{
                                this.changeBlankPage(false)
                            }
                        },
                        error => {
                            // 执行失败的回调函数
                            console.log(error);
                        });
            },
            // 持仓温度等级设置
            setTemperatureGrade:function(){
                if(this.holding_temperature<=20){
                    this.classTemperatureGradeObject={
                        step1: true
                    }
                    this.holdingProposal="持仓建议：回避为上策";
                }else if(this.stk_data.ZhangDie>=0 && this.holding_temperature<=50){
                    this.classTemperatureGradeObject={
                        step2: true
                    }
                    this.holdingProposal="持仓建议：宜适中仓位";
                }else if(this.stk_data.ZhangDie<0 && this.holding_temperature<=50){
                    this.classTemperatureGradeObject={
                        step2: true
                    }
                    this.holdingProposal="持仓建议：宜较低仓位";
                }else if(this.stk_data.ZhangDie>=0 && this.holding_temperature>=50){
                    this.classTemperatureGradeObject={
                        step3: true
                    }
                    this.holdingProposal="持仓建议：宜较高持仓";
                }else if(this.stk_data.ZhangDie<0 && this.holding_temperature>=50){
                    this.classTemperatureGradeObject={
                        step3: true
                    }
                    this.holdingProposal="持仓建议：宜适中持仓";
                }else if(this.holding_temperature>=80){
                    this.classTemperatureGradeObject={
                        step4: true
                    }
                    this.holdingProposal="持仓建议：积极参与";
                }else{
                    this.classTemperatureGradeObject={
                        step4: true
                    }
                    this.holdingProposal="--";
                }
            },
            // 持仓温度帮助弹窗
            toggle: function () {
                this.isHelp =! this.isHelp;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/ccwd.vue